import { SvgIcon } from '@mui/material';
import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

const IconTelegram = ({ height, width }) => (
  <SvgIcon
    focusable="false"
    viewBox={!isNil(height) && !isNil(width) ? `0 0 ${width} ${height}` : '0 0 74 75'}
    aria-hidden="true"
    width={width || '74'}
    height={height || '75'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      width: !isNil(width) ? `${width}px` : 'inherit', // TODO: get the width
      height: !isNil(height) ? `${height}px` : 'inherit',
    }}
  >
    <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1144_3737)">
        <g filter="url(#filter0_d_1144_3737)">
          <rect x="4" width="70" height="70" rx="35" fill="url(#paint0_linear_1144_3737)" shape-rendering="crispEdges" />
          <circle cx="39" cy="35" r="35" fill="url(#paint1_linear_1144_3737)" fill-opacity="0.25" />
          <g filter="url(#filter1_d_1144_3737)">
            <path d="M18.7543 32.2064C29.5129 27.5498 36.6853 24.4798 40.2715 22.9963C50.5228 18.7608 52.6503 18.0251 54.0398 18.0002C54.3454 17.9953 55.0257 18.0704 55.4697 18.427C55.8387 18.7278 55.9424 19.1346 55.9943 19.4202C56.0405 19.7055 56.1039 20.3557 56.052 20.8633C55.4985 26.6612 53.0942 40.7308 51.8719 47.2248C51.3588 49.9725 50.3383 50.8937 49.3524 50.9836C47.2076 51.1796 45.5817 49.5766 43.506 48.2251C40.26 46.1093 38.4265 44.7928 35.2728 42.7286C31.6289 40.3429 33.9928 39.0315 36.0684 36.8889C36.6104 36.328 46.0544 27.7944 46.2332 27.0204C46.2562 26.9236 46.2793 26.5627 46.0602 26.3725C45.8469 26.1817 45.5298 26.247 45.2991 26.2986C44.9705 26.3719 39.7872 29.7796 29.732 36.521C28.2618 37.5259 26.9299 38.0158 25.7307 37.99C24.4161 37.9619 21.8793 37.2498 19.9939 36.6414C17.6877 35.8949 15.8484 35.5001 16.0099 34.2323C16.0906 33.5723 17.0073 32.8968 18.7543 32.2064Z" fill="white" />
          </g>
        </g>
      </g>
      <defs>
        <filter id="filter0_d_1144_3737" x="0" y="0" width="78" height="78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1144_3737" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1144_3737" result="shape" />
        </filter>
        <filter id="filter1_d_1144_3737" x="14" y="18" width="44.0713" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.499031 0 0 0 0 0.762256 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1144_3737" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1144_3737" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_1144_3737" x1="39" y1="0" x2="39" y2="70" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A5E0FF" />
          <stop offset="0.503652" stop-color="#22A6EA" />
          <stop offset="1" stop-color="#006295" />
        </linearGradient>
        <linearGradient id="paint1_linear_1144_3737" x1="14.0962" y1="10.0962" x2="63.9038" y2="61.25" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="1" stop-color="#002132" />
        </linearGradient>
        <clipPath id="clip0_1144_3737">
          <rect width="78" height="78" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

IconTelegram.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default IconTelegram;
